import React from 'react';

interface ArrowProps {
    angle: number;
    color?: string;
}

const Arrow: React.FC<ArrowProps> = ({ angle, color = 'black' }) => (
    <polyline points={'500 800 500 250 480 250 500 200 520 250 500 250'} transform={`rotate(${angle} 500 500)`} strokeWidth='10' stroke='black' fill={color} />
);

export default Arrow;
